<template>
  <div>
    <div class="pb-4">
      <span class="text-chips md:block md:text-center">Paso Uno: </span>
      <h2 class="headline-sm pb-1 md:headline-md md:text-center">Datos Generales</h2>
      <p class="subhead-2 text-on-surface-variant md:subhead-1 md:text-center">
        Confirma los datos generales de tu perfil
      </p>
    </div>
    <div>
      <div class="flex flex-col sm:flex-row sm:gap-2">
        <div class="flex-1">
          <FormInputText
            id="name"
            v-model="form.name"
            label="Nombres"
            :required="true"
            :error="errors.name"
          />
        </div>
        <div class="flex-1">
          <FormInputText
            id="lastname"
            v-model="form.lastname"
            label="Apellidos"
            :required="true"
            :error="errors.lastname"
          />
        </div>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-2">
        <div class="flex-1">
          <FormInputText
            id="date_of_birth"
            v-model="form.date_of_birth"
            type="date"
            label="Fecha de Nacimiento"
            :required="true"
            :error="errors.date_of_birth"
          />
        </div>
        <div class="flex-1">
          <FormSelect
            id="gender"
            v-model="form.gender"
            label="Género"
            :required="true"
            :error="errors.gender"
          >
            <option value="" disabled>Seleccionar</option>
            <option v-for="(gender, key) in ['Femenino', 'Masculino', 'Otro']" :key="key">
              {{ gender }}
            </option>
          </FormSelect>
        </div>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-2">
        <div class="flex-1">
          <FormInputText
            id="dui"
            v-model="form.personal_id"
            label="DUI / Pasaporte / Carnet de Residente"
            :required="true"
            :error="errors.dui"
          />
        </div>
        <div class="flex-1">
          <FormInputText
            id="phone_number"
            v-model="form.phone_number"
            label="Teléfono"
            :error="errors.phone_number"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateRequiredKeys } from '@/utilities.helpers.js'
import FormInputText from '@/Components/FormInputText'
import FormSelect from '@/Components/FormSelect'

export default {
  name: 'ApplicantProfileCreateStepOne',
  components: {
    FormInputText,
    FormSelect,
  },
  props: {
    config: {
      type: Object,
      validator: value => {
        return validateRequiredKeys(value, ['form_data'])
      },
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      form: {
        name: this.config.form_data.name,
        lastname: this.config.form_data.lastname,
        personal_id: this.config.form_data.personal_id,
        date_of_birth: this.config.form_data.date_of_birth,
        gender: this.config.form_data.gender,
      },
    }
  },
  watch: {
    /* Watch for any update on this.form object and emit event if update is found */
    form: {
      deep: true, // Will check for updates on nested properties
      handler(value) {
        this.$emit('update-content', 'profile', value)
      },
    },
  },
}
</script>
